import React, { useState, useEffect, useContext } from 'react';
import { useParams, useLocation, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import UserContext from '../../components/User_Context.js';
import * as menu from "../../assets/menus/menu.js";
import * as breadcrumb from "../../components/ui/breadcrumb.js";
import * as  api from '../../api/apiConnector.js'
import waiting from '../../assets/images/waiting.svg'
/**
 * OAuth Callback Screen
 * Displays all page payload information including URL parameters, query strings, and page metadata
 */
const OAuth_Callback_Screen = () => {
    const { t } = useTranslation();
    const params = useParams();
    const location = useLocation();
    const navigate = useNavigate();

    // State for dynamic page information
    const [queryParams, setQueryParams] = useState({});
    const [codeParams, setCodeParams] = useState(null);

    // Set up breadcrumb navigation
    const setBreadCrumb = () => {
        const path = [
            { link: "/", name: t('home', { ns: 'labels', defaultValue: 'Home' }) },
            { link: "/auth/callback", name: "OAuth Callback" }
        ];
        breadcrumb.set(path);
    };

    // Extract and process page information
    const extractPageInfo = () => {


        // Query Parameters from URL search string
        const searchParams = new URLSearchParams(location.search);
        const queryParamsObj = {};
        searchParams.forEach((value, key) => {
            queryParamsObj[key] = value;
        });
        setQueryParams(queryParamsObj);

        if (queryParamsObj.code) {
            setCodeParams(queryParamsObj.code)
        }

    };


    // Initialize component
    useEffect(() => {
        (async () => {
            // Initialize menu with current user

            // Set breadcrumb

            // Extract all page information
            extractPageInfo();
        })();
    }, []);

    // Update information when location changes
    useEffect(() => {
        extractPageInfo();
    }, [location, params]);

    useEffect(() => {
        if (codeParams && codeParams != '') {
            (async () => {
                const resultCheckToken = await api.sendMessage("security/OAuthCheckTokenAPI", {

                    body: {
                        code: codeParams
                    }

                });

                var test = 1;
                if (resultCheckToken?.success && resultCheckToken.user ) {
                    resultCheckToken.user.token = resultCheckToken.token;
                    localStorage.setItem("user", JSON.stringify(resultCheckToken.user));

                  
                        window.document.location.href = "/";
                 
                }
                else{
                    console.log('failed');
                       window.document.location.href = "/afterLoginError"
                }


            })();
        }
    }, [codeParams])





    // Render JSON in formatted way
    const renderJSON = (data, title) => {
       
        return (
            <div class="text-center"><img src={waiting} /></div>
        );
    };

    // Render key-value pairs in table format
    const renderTable = (data, title) => {
        if (!data || Object.keys(data).length === 0) {
            return (
                <div className="alert alert-info">
                    <strong>{title}:</strong> No data available
                </div>
            );
        }

        return (
            <div className="card mb-4">
                <div className="card-header">
                    <h5 className="mb-0">{title}</h5>
                </div>
                <div className="card-body">
                    <div className="table-responsive">
                        <table className="table table-striped table-bordered">
                            <thead className="thead-dark">
                                <tr>
                                    <th style={{ width: '30%' }}>Property</th>
                                    <th style={{ width: '70%' }}>Value</th>
                                </tr>
                            </thead>
                            <tbody>
                                {Object.entries(data).map(([key, value]) => (
                                    <tr key={key}>
                                        <td><strong>{key}</strong></td>
                                        <td>
                                            <code>
                                                {typeof value === 'object'
                                                    ? JSON.stringify(value, null, 2)
                                                    : String(value)
                                                }
                                            </code>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        );
    };

    return (
        <div id="preloader">
		<div class="lds-ripple">
			<div></div>
			<div></div>
		</div>
    </div>
        // <div className="container-fluid">
        //     <div className="row">
        //         <div className="col-12">
        //             <div className="card">
        //                 <div className="card-header">
        //                     <h4 className="card-title">
        //                         <i className="fas fa-info-circle me-2"></i>
        //                         Page Payload Information
        //                     </h4>
        //                     <p className="text-muted mb-0">
        //                         Complete information about current page parameters, query strings, and browser environment
        //                     </p>
        //                 </div>
        //                 <div className="card-body">


        //                     {/* Query Parameters */}
        //                     {renderTable(queryParams, "Query Parameters (URLSearchParams)")}



        //                 </div>
        //             </div>
        //         </div>
        //     </div>
        // </div>
    );
};

export default OAuth_Callback_Screen;
